module.exports = __webpack_public_path__ + "img/memory_mob_hover.c2c41d8a.svg";